"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const toolkit_1 = require("@reduxjs/toolkit");
const app_types_1 = require("pages/app.types");
const brand_types_1 = require("./brand.types");
const initialState = {
    isLoading: true,
    isError: false,
    isSuccess: false,
    errorCode: 0,
    errorMessage: '',
    dataGrid: [],
    dataColor: [],
    mutationMode: false,
    dataItem: {
        id: '0',
        code: '',
        name: '',
        color: 'none',
        is_active: true,
        created_by: '',
        created_date: new Date(),
        modified_by: '',
        modified_date: new Date()
    },
    dataStates: {
        filterable: true,
        sortable: true,
        reorderable: false,
        scrollable: 'scrollable',
        skip: 0,
        take: 10,
        total: 0,
        sort: [{ field: 'modified_date', dir: 'desc' }]
    }
};
const brandReducer = (0, toolkit_1.createReducer)(initialState, {
    [app_types_1.appTypes.RESET_LOADING]: () => {
        return Object.assign({}, initialState);
    },
    [brand_types_1.brandTypes.SET_DATA_GRID]: (state, action) => {
        const { dataGrid, count } = action.payload;
        return Object.assign(Object.assign({}, state), { dataGrid, isLoading: false, dataStates: Object.assign(Object.assign({}, state.dataStates), { total: count }) });
    },
    [brand_types_1.brandTypes.ON_PAGE_CHANGE]: (state, action) => {
        const { dataStates } = action.payload;
        return Object.assign(Object.assign({}, state), { dataStates, isLoading: true });
    },
    [brand_types_1.brandTypes.ON_MUTATION_CLICK]: (state, action) => {
        const { dataItem, mutationMode, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { mutationMode: mutationMode, dataItem: dataItem ? dataItem : initialState.dataItem, isSuccess: isSuccess ? isSuccess : initialState.isSuccess });
    },
    [brand_types_1.brandTypes.ON_SAVE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.map(item => {
                if (item.id === (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id))
                    return dataItem;
                return item;
            }) });
    },
    [brand_types_1.brandTypes.ON_DELETE_DATAITEM]: (state, action) => {
        const { dataItem, isSuccess } = action.payload;
        return Object.assign(Object.assign({}, state), { isSuccess, mutationMode: false, dataItem: initialState.dataItem, dataGrid: state.dataGrid.filter(item => item.id !== (dataItem === null || dataItem === void 0 ? void 0 : dataItem.id)) });
    },
    [brand_types_1.brandTypes.ON_FILTER_CHANGE]: (state, aciton) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { filter: aciton.payload, skip: initialState.dataStates.skip }) });
    },
    [brand_types_1.brandTypes.ON_SORT_CHANGE]: (state, aciton) => {
        return Object.assign(Object.assign({}, state), { isLoading: true, dataStates: Object.assign(Object.assign({}, state.dataStates), { sort: aciton.payload }) });
    },
    [brand_types_1.brandTypes.SET_ERROR]: (state, action) => {
        const { errorCode, isError, errorMessage } = action.payload;
        return Object.assign(Object.assign({}, state), { isLoading: false, isError,
            errorCode,
            errorMessage, isSuccess: false });
    },
    [brand_types_1.brandTypes.SET_LOADING]: (state, action) => {
        return Object.assign(Object.assign({}, state), { isLoading: action.payload });
    },
    [brand_types_1.brandTypes.SET_DATA_ENUM]: (state, action) => {
        const color_data = action.payload.find(x => x.value === state.dataItem.color) ||
            {
                id: '',
                type: '',
                value: '',
                is_active: false,
                created_by: '',
                created_date: new Date(),
                modified_by: '',
                modified_date: new Date()
            };
        return Object.assign(Object.assign({}, state), { dataColor: action.payload, dataItem: Object.assign(Object.assign({}, state.dataItem), { color_data, color: color_data.value }) });
    },
});
exports.default = brandReducer;
